<script>
  import Button from '../../assets/general/whiteButton.svelte';
</script>

<div class="documentary-section">
  <div class="content" style="margin-left: 3rem; margin-right: 3rem;">
    <h2>Watch our New PBS Documentary!</h2>
    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/358915135?h=9e093379da&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="TRAILER: Stories from the Heart"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
    <p><br><strong>Did you know?</strong><br><br>Your organization can host a Documentary Screening with a Q&A featuring Erin Gruwell and the Freedom Writers.</p>
    <a href="mailto:sueellen@freedomwritersfoundation.org"><button>BOOK A SCREENING</button></a>
  </div>
  <div class="image">
    <!-- Replace 'image.jpg' with the actual path to your image -->
    <img src="../images/other/DocPoster.png" alt="Freedom Writers: Stories from the Heart Poster">
  </div>
</div>

<style>
.documentary-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background-color: #080605;
  color: #fff;
  height: 700px;
}
.content {
  flex-basis: 50%; /* Adjust the width as necessary */
  padding: 34px; /* Adjust spacing between text and image */
}

.image {
  flex-basis: 50%; /* Adjust the width as necessary */
}
.image img {
  width: 100%;
  height: auto;
  display: block; /* Remove any default margins */
}
@media (max-width: 768px) {
  .image {
    display: none; /* Hide the image */
  }
  .documentary-section {
    height: 500px;
  }

  .content {
    flex-basis: 100%; /* Allow the content to take full width */
    padding: 17px; /* Adjust spacing between text and image */
  }
  .content h2 {
  font-size: 24px; /* Adjust the size as necessary */
  margin-bottom: 5px; /* Adjust the spacing as necessary */
}

.content p {
  font-size: 16px; /* Adjust the size as necessary */
  margin-bottom: 10px; /* Adjust the spacing as necessary */
}
}

.content h2 {
  font-size: 24px; /* Adjust the size as necessary */
  margin-bottom: 10px; /* Adjust the spacing as necessary */
}

.content p {
  font-size: 16px; /* Adjust the size as necessary */
  margin-bottom: 20px; /* Adjust the spacing as necessary */
}

.content iframe {
  width: 100%; /* Responsive width */
  height: auto; /* Adjust height based on aspect ratio */
  margin-bottom: 20px; /* Adjust the spacing as necessary */
}
  button {
    font-weight: bold;
    font-size: 16px;
    background-color: #fff;
    color: black;
    text-decoration: none;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    text-transform: uppercase;
    transition: 0.3s ease;
  }

  button:hover {
    scale: 1.17;
  }
</style>